<template lang="pug">
	.app-core--rrule-field
		.clickable.hoverable(v-if="editable", @click="show") {{readableRRule}}
		span(v-else) {{readableRRule}}
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :value="value", @change="v => changedRRule = v", @success="$emit('save', $refs.rruleEditor.rrule)", :title="$tCaption('Recurrence rule')",
			:defaultActions="true", :width="400", :height="450")
			RRuleEditor(ref="rruleEditor", :value.sync="changedRRule")
			template(slot="actions-left")
				DxButton(:text="$tCaption('Clear')", type="danger", @click="clear")
</template>

<script>
import VueTypes from 'vue-types';
import RRuleEditor from './RRuleEditor.vue';
import Popup from 'app-core/Popup.vue';
import DxButton from 'devextreme-vue/button';
import { REPEAT_TYPES, WEEK_DAYS, MONTHS, getReadableStringFromRRule } from 'app-core/rrule';

export default {
	name: 'app-core--rrule-field',
	translationCategory: 'Scheduling',
	props: {
		value: VueTypes.string.def(null),
		editable: VueTypes.bool.def(false)
	},
	components: { RRuleEditor, Popup, DxButton },
	data() {
		const repeatTypes = REPEAT_TYPES.toLocale('name', this).map(f => ({ ...f, text: f.name }));
		const weekDays = WEEK_DAYS.toLocale('name', this).map(f => ({ ...f, text: f.name }));
		const months = MONTHS.toLocale('name', this).map(f => ({ ...f, text: f.name }));

		return {
			popupVisible: false,
			repeatTypes,
			weekDays,
			months,
			changedRRule: this.value
		}
	},
	computed: {
		readableRRule() {
			return getReadableStringFromRRule(this.value);
		}
	},
	watch: {
	
	},
	mounted() {
		if (__DEBUG__)
			window.rruleField = this;
	},
	methods: {
		clear() {
			this.popupVisible = false;
			this.$emit('save', null);
		},
		show() {
			this.popupVisible = false;
			this.changedRRule = this.value;
			this.$nextTick(() => {
				this.popupVisible = true;
			});
		}
	}
};

</script>

<style lang="scss">
	.app-core--rrule-editor {
		
	}
</style>
